import { NoResultsIcon } from "ui/gluestack/icon/NoResultsIcon";
import { View } from "../view";
import { Text } from "react-native";
import { Icon } from "ui/gluestack/icon";

interface Props {
  title?: string;
  subtitle?: string;
  className?: string;
}
export const NoItemsComponent = ({ title, subtitle, className }: Props) => {
  return (
    <View className={`items-center ${className}`}>
      <View className="gap-2 items-center max-w-64">
        <View className="gap-2 items-center justify-center">
          <Icon as={NoResultsIcon} className="h-40 w-40" />
          <Text className="text-typography-700">{title ?? "No Results"}</Text>
        </View>
        {subtitle ? (
          <Text className="text-center text-xs text-typography-500">
            {subtitle}
          </Text>
        ) : null}
      </View>
    </View>
  );
};
